
import React from "react";
import { Button } from "@/components/ui/button";
import { useAdminDashboard } from "@/contexts/AdminDashboardContext";

interface AdminDashboardHeaderProps {
  className?: string;
}

const AdminDashboardHeader: React.FC<AdminDashboardHeaderProps> = ({ className }) => {
  const { 
    setIsScheduleDialogOpen,
    setIsAddClassOpen
  } = useAdminDashboard();
  
  return (
    <div className={`flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4 ${className || ""}`}>
      <div>
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <p className="text-muted-foreground">Manage classes, bookings, users, subscriptions, and gift cards</p>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          onClick={() => setIsScheduleDialogOpen(true)}
        >
          Schedule 8 Weeks
        </Button>
        <Button 
          onClick={() => setIsAddClassOpen(true)}
        >
          Add New Class
        </Button>
      </div>
    </div>
  );
};

export default AdminDashboardHeader;
